import React from "react";
import Footer from "../../../../containers/Footer";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

import VIPBanner from "../../../../assets/images/banner/vipbanner.webp"
import star from "../../../../assets/images/icons/vip-pass.png";

const VIP = () => {
    return (
        <>
            <HeaderAfterLogin />
            <div className="container-fluid">
                <main className="main">
                    <div className="OffersSection">
                        <div className="OfferBanner">
                            <img src={VIPBanner} alt="Offerbanner" />
                        </div>

                        <div className="Offercontent">
                            <p><img src={star} alt="start" />FUNN777 VIP AND VVIP<img src={star} alt="start" /></p>
                            <p>VIP PLAN</p>
                            <ul className="VIPOffers">
                                <li><span>15000/- Advance Deposit :-</span> Benefits - Withdrawal Limit - 1. 2 LAKH Daily... 2%+1% Extra cash Deposit Bonus... Priority customer Service...Min daily deposit of 8000/- Required... Validity 60 days .. 240000/- Monthly Average Deposit..</li>
                                <li><span>45000/- Advance deposit :-</span>Benefits - Withdrawal Limit - 2 Lakh Daily.... Priority Customer Service.. Daily Deposit Or Monthly Average Deposit..15000/- or 450000/- Monthly...2% + 3% Cash Bonus Extra on Each Deposit.. Extra Deposit Bonus will be given on Every Saturday At a Time...Validity 88Days...</li>
                            </ul>
                            <p>VVIP BONUS</p>
                            <ul className="VIPOffers">
                                <li><span>Advance Deposit of 99000/ :-</span>Benefits - Withdrawal Limit 3.5 lakh Daily...</li>
                                <li>
                                    <span>Daily Deposit... 25000/- and 750000/- Monthly Required</span> Extra 2%+3%+2% Cash Deposit Bonus on Every Deposit... Loosing Commission Extra 10%+ 5% In Coins... Validity 100 days..
                                </li>
                            </ul>
                            <p>VVIP Special Customer service No. Alloted to customer And Issues Will be Resolved in 30 min...</p>
                            <p>EXCLUSIVE BENEFITS FOR ALL 3 PACKAGES... VIP AND VVIP...</p>
                            <ul>
                                <li>Special Dedicated Contact No. For Solving any Kind of Issues.. And it will be Given to only and only VIP And VVIP Customers...</li>
                                <li>24/7 Special services..</li>
                                <li>Withdrawal Updates if any issue in delay Usually Due to Banking Server Issues....</li>
                            </ul>
                            <p><span>Note - </span>This is a LIMITED PERIOD Offer Of VIP and VVIP</p>
                            <p>DEPOSIT Amount is Non Refundable....</p>
                            <p>All Extra Deposit Bonus will be Added at once on every Saturday..</p>
                            <p>Please Message on customer Support Or To your Agent To Join VIP And VVIP Plan..</p>
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
  );
}

export default VIP;